export default __webpack_public_path__ + "static/55829341-7154-4033-94b2-e501980cf459-58fb1c0ab4b23e6ca6c317c2cf7f34d4.woff";